import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { BLACK_FRIDAY_DEALS_TYPE } from '../../../brands/default/constants';
import ThemeContext from '../../../providers/ThemeProvider';
import CategoryItem from './CategoryItem';

const BlackFridayHeaderNavigationPopover = ({ category }) => {
  const theme = useContext(ThemeContext);

  const {
    APPLE,
    SAMSUNG,
    BEAUTY,
    BED,
    CHRISTMAS,
    FASHION,
    HOME,
    JEWELLERY,
    KIDS,
    LAPTOP,
    LOCAL,
    TECH,
    VIEW_ALL_DEALS,
    WATCHES,
  } = BLACK_FRIDAY_DEALS_TYPE;

  const giftsByApple = category?.subNavigations?.filter(
    (cat) => cat.navigationType === APPLE,
  );

  const giftsBySamsung = category?.subNavigations?.filter(
    (cat) => cat.navigationType === SAMSUNG,
  );

  const giftsByLaptop = category?.subNavigations?.filter(
    (cat) => cat.navigationType === LAPTOP,
  );

  const giftsByTech = category?.subNavigations?.filter(
    (cat) => cat.navigationType === TECH,
  );

  const giftsByBed = category?.subNavigations?.filter(
    (cat) => cat.navigationType === BED,
  );

  const giftsByHome = category?.subNavigations?.filter(
    (cat) => cat.navigationType === HOME,
  );

  const giftsByFashion = category?.subNavigations?.filter(
    (cat) => cat.navigationType === FASHION,
  );

  const giftsByBeauty = category?.subNavigations?.filter(
    (cat) => cat.navigationType === BEAUTY,
  );

  const giftsByJewellery = category?.subNavigations?.filter(
    (cat) => cat.navigationType === JEWELLERY,
  );

  const giftsByWatches = category?.subNavigations?.filter(
    (cat) => cat.navigationType === WATCHES,
  );

  const giftsByKids = category?.subNavigations?.filter(
    (cat) => cat.navigationType === KIDS,
  );

  const giftsByChristmas = category?.subNavigations?.filter(
    (cat) => cat.navigationType === CHRISTMAS,
  );

  const giftsByLocal = category?.subNavigations?.filter(
    (cat) => cat.navigationType === LOCAL,
  );

  return (
    <>
      <div className="navigation-popover">
        <div className="navigation-popover__column">
          <CategoryItem categoryArray={giftsByApple} categoryName={APPLE} />
          <br />
          <CategoryItem categoryArray={giftsBySamsung} categoryName={SAMSUNG} />
          <br />
          <CategoryItem categoryArray={giftsByLaptop} categoryName={LAPTOP} />
          <br />
          <CategoryItem categoryArray={giftsByTech} categoryName={TECH} />
        </div>
        <div className="navigation-popover__column">
          <CategoryItem categoryArray={giftsByBed} categoryName={BED} />
          <br />
          <CategoryItem categoryArray={giftsByHome} categoryName={HOME} />
          <br />
          <CategoryItem categoryArray={giftsByKids} categoryName={KIDS} />
          <br />
        </div>
        <div className="navigation-popover__column">
          <CategoryItem categoryArray={giftsByFashion} categoryName={FASHION} />
          <br />
          <CategoryItem categoryArray={giftsByBeauty} categoryName={BEAUTY} />
          <br />
          <CategoryItem
            categoryArray={giftsByJewellery}
            categoryName={JEWELLERY}
          />
          <br />
          <CategoryItem categoryArray={giftsByWatches} categoryName={WATCHES} />
          <br />
          <CategoryItem categoryArray={giftsByFashion} categoryName={FASHION} />
          <br />
        </div>
        <div className="navigation-popover__column">
          <CategoryItem
            categoryArray={giftsByChristmas}
            categoryName={CHRISTMAS}
          />
          <br />
          <CategoryItem categoryArray={giftsByLocal} categoryName={LOCAL} />
          <br />
          <h3>
            <Link href="/guides/black-friday-deals">
              <a className="navigation-popover__link">{VIEW_ALL_DEALS}</a>
            </Link>
          </h3>
        </div>
      </div>
      <style jsx>{`
        .navigation-popover__column {
          padding: 0 15px;
          border-right: 1px solid #cccccc;
          flex-grow: 1;
          flex-basis: 0;
        }
        .navigation-popover__column:first-child {
          padding-left: 0;
        }
        .navigation-popover__column:last-child {
          border-right: none;
          padding-right: 0;
        }

        .navigation-popover__link {
          color: #000000;
        }
        .navigation-popover__link--small-only {
          display: none;
        }
        .navigation-popover__link:hover {
          color: ${theme.colors.navlinkactive};
        }

        .navigation-popover__deals {
          align-item: top;
          display: flex;
          flex-wrap: wrap;
          min-width: 600px;
          padding: 0 8px;
          margin-top: -15px;
          width: 600px;
        }
        .navigation-popover__inner {
          display: flex;
          padding: 15px 7px 0;
          width: 50%;
        }
        .deal-card--placeholder {
          width: 100%;
          padding-bottom: 66.9%;
          background-color: #eeeeee;
        }

        @media (max-width: ${theme.breakpoints.xlDown}) {
          .navigation-popover__link--small-only {
            display: block;
          }
          .navigation-popover__column:first-child {
            display: none;
          }
          .navigation-popover__column:nth-child(2) {
            padding-left: 0;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .navigation-popover__deals {
            width: 525px;
            min-width: 525px;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .navigation-popover {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

BlackFridayHeaderNavigationPopover.propTypes = {
  category: PropTypes.object,
};

export default BlackFridayHeaderNavigationPopover;
